import React from 'react';
import Moment from 'react-moment';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Avatar from '@material-ui/core/Avatar';
import DetailInformationAsset from './DetailInformationAsset';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  assetCard: {
    height: 60,
    background: 'white',
    marginTop: 8
  },
  assetCardContent: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    padding: '10px 12px 12px 14px',
    '&:last-child': {
      paddingBottom: 10
    },
    position: 'relative'
  },
  avatar: {
    marginTop: 4,
    marginBottom: 4,
    height: 40,
    width: 40
  },
  logo: {
    width: '80%'
  }
}));

function CardAsset ({ asset, configFile }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const classes = useStyles();

  const assetType = configFile.assetTypes.find(
    assetType => assetType.id === asset.assetType
  );

  return (
    <>
      <Card className={classes.assetCard} onClick={handleClickOpen}>
        <CardContent className={classes.assetCardContent}>
          <Avatar className={classes.avatar}>
            {' '}
            <img
              src={
                assetType && assetType.logo && assetType.logo !== ''
                  ? assetType.logo
                  : configFile.logo
              }
              alt='logo'
              className={classes.logo}
            />{' '}
          </Avatar>
          <div>
            <Typography
              color='textSecondary'
              style={{
                fontFamily: 'Roboto-Regular',
                fontSize: '14px',
                color: 'rgba(0,0,0,0.87)',
                letterSpacing: '0.25px',
                textAlign: 'left',
                lineHeight: '20px',
                paddingLeft: 14,
                paddingTop: 4,
                fontWeight: '500',
                marginBottom: 0
              }}
              gutterBottom
            >
              {asset.name}
            </Typography>
            <Typography
              color='textSecondary'
              style={{
                fontFamily: 'Roboto-Regular',
                fontSize: '14px',
                color: 'rgba(0,0,0,0.60)',
                letterSpacing: '0.25px',
                textAlign: 'left',
                lineHeight: '20px',
                position: 'absolute',
                paddingLeft: 14,
                fontWeight: '500',
                marginBottom: '14'
              }}
              gutterBottom
            >
              <Moment format='DD/MM/YYYY HH:mm'>
                {
                  new Date(
                    asset.tx_timeStamp
                      .replace(' +0000 UTC', 'Z')
                      .replace(' ', 'T')
                  )
                }
              </Moment>
            </Typography>
          </div>
        </CardContent>
      </Card>
      {open && (
        <DetailInformationAsset asset={asset} open={open} setOpen={setOpen} />
      )}
    </>
  );
}

export default CardAsset;
